import React from "react";
import PageBanner from "../components/PageBanner";
import Layouts from "../layouts/Layouts";

import beach from "../assets/images/beach.jpg";
import gym from "../assets/images/gym-new.jpg";
import rentBicycle from "../assets/images/rent-bicycle.jpg";
import indoorSwimmingPool from "../assets/images/indoor-swimming-pool-new.jpg";
import restaurant from "../assets/images/restaurant.jpg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import EmbedVideo from "../components/EmbedVideo";

const Sport = () => {
  const { t } = useTranslation();
  return (
    <Layouts>
      <PageBanner pageName={t("sport")} />

      <section className="section-sixteen">
        <div className="auto-container">
          <div className="sport-stack">
            <div className="row no-gutters">
              <div className="col-lg-6">
                <div className="block-sixteen">
                  <h4>{t("admiral-beach")}</h4>
                  <div className="text">
                    <p>{t("admiral-beach-text-1")}</p>
                    <p>{t("admiral-beach-text-2")}</p>
                  </div>
                  <div className="icon">
                    <i className="flaticon-clock" />
                    <span>{t("admiral-beach-working-hours")}</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="image">
                  <img src={beach} alt="" />
                </div>
              </div>
            </div>
            <div className="row no-gutters">
              <div className="col-lg-6 order-lg-2">
                <div className="block-sixteen">
                  <h4>{t("outdoor-swimming-pool")}</h4>
                  <div className="text">{t("outdoor-swimming-pool-text")}</div>
                  <div className="icon">
                    <i className="flaticon-clock" />
                    <span>{t("outdoor-swimming-pool-working-hours")}</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <EmbedVideo
                  className="image sport__spa-video"
                  src="https://www.youtube.com/embed/mv2kCkntHjo"
                  title={t("hotel-admiral")}
                />
              </div>
            </div>
            <div className="row no-gutters">
              <div className="col-lg-6">
                <div className="block-sixteen">
                  <h4>{t("spa")}</h4>
                  <div className="text">
                    <p>{t("spa-text-1")}</p>
                    <p>{t("spa-text-2")}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <EmbedVideo
                  className="image sport__spa-video"
                  src="https://www.youtube.com/embed/Y1v8r1zp3iQ"
                  title={t("hotel-admiral")}
                />
              </div>
            </div>
            <div className="row no-gutters">
              <div className="col-lg-6">
                <div className="image">
                  <img src={gym} alt="" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="block-sixteen">
                  <h4>{t("gym")}</h4>
                  <div className="text">
                    <p>{t("gym-text-1")}</p>
                    <p>{t("gym-text-2")}</p>
                  </div>
                  <div className="icon">
                    <i className="flaticon-clock" />
                    <span>{t("gym-working-hours")}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row no-gutters">
              <div className="col-lg-6">
                <div className="block-sixteen">
                  <h4>{t("ultra-all-inclusive")}</h4>
                  <div className="text">
                    <p>{t("ultra-all-inclusive-text-1")}</p>
                    <p>{t("ultra-all-inclusive-text-2")}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="image">
                  <img src={restaurant} alt="" />
                </div>
              </div>
            </div>
            <div className="row no-gutters">
              <div className="col-lg-6 order-lg-2">
                <div className="block-sixteen">
                  <h4>{t("indoor-swimming-pool")}</h4>
                  <div className="text">{t("indoor-swimming-pool-text")}</div>
                  <div className="icon">
                    <i className="flaticon-clock" />
                    <span>{t("indoor-swimming-pool-working-hours")}</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="image">
                  <img src={indoorSwimmingPool} alt="" />
                </div>
              </div>
            </div>
            <div className="row no-gutters">
              <div className="col-lg-6">
                <div className="block-sixteen">
                  <h4>{t("bicycle-rent")}</h4>
                  <div className="text">{t("bicycle-rent-text")}</div>
                  <div className="icon">
                    <i className="flaticon-clock" />
                    <span>{t("bicycle-rent-working-hours")}</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="image">
                  <img src={rentBicycle} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-one">
        <div className="auto-container">
          <div className="block-two text-center">
            <h2 className="sec-title">
              <span className="theme-color">{t("final-cta-title")}</span>
            </h2>
            <div className="text-two">
              <p>{t("final-cta-text-1")}</p>
              <p>{t("final-cta-text-2")}</p>
            </div>
            <div className="bottom-content justify-content-center">
              <Link to="/rooms" className="theme-btn btn-style-one dark">
                <span>{t("rooms-and-suites")}</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </Layouts>
  );
};
export default Sport;
